import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changeStatus'
})
export class ChangeStatusPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value ? 'Desactivar' : 'Activar';
  }

}
